import { defineAsyncComponent } from 'vue';
import EventsGrid from './Components/EventsGrid.vue';
import LogoSwitch from './Components/LogoSwitch.vue';
import MenuScroll from './Components/MenuScroll.vue';
import Modal from './Components/Modal.vue';
import MultiCarousel from './Components/MultiCarousel.vue';
import RevealMenu from './Components/RevealMenu.vue';
import VueImage from './Components/VueImage.vue';
import VueLoop from './Components/VueLoop.vue';

export default {
    'v-image': VueImage,
    'reveal-menu': RevealMenu,
    'logo-switch': LogoSwitch,
    'menu-scroll': MenuScroll,
    'modal': Modal,
    'slide-show': defineAsyncComponent(() => import('./Components/SlideShow.vue')),
    'carousel': defineAsyncComponent(() => import('./Components/Carousel.vue')),
    'events-grid': EventsGrid,
    'vue-loop': VueLoop,
    'multi-carousel': MultiCarousel,
};
